import { render, staticRenderFns } from "./YoutubeRecent.vue?vue&type=template&id=978e53a0&"
import script from "./YoutubeRecent.vue?vue&type=script&lang=ts&"
export * from "./YoutubeRecent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports